const isMobile = navigator.userAgent.toLowerCase().match(/mobile/i);
const isTablet = navigator.userAgent.toLowerCase().match(/tablet/i);
const device = {
  type: () => {
    if (isMobile) return "mobile";
    if (isTablet) return "tablet";
    return "desktop";
  }
};
export { device };